import { render, staticRenderFns } from "./nft.vue?vue&type=template&id=02c8e4ad&scoped=true&"
import script from "./nft.vue?vue&type=script&lang=js&"
export * from "./nft.vue?vue&type=script&lang=js&"
import style0 from "./nft.vue?vue&type=style&index=0&id=02c8e4ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c8e4ad",
  null
  
)

export default component.exports